import * as React from "react";
import get from "lodash/get";

import "./CurrentTier.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { StoreState } from "../../reducers";

export interface CurrentTierProps extends ComponentBaseProps {
  onClick: () => void;
  action: string;
  successScreen: string;
  mode: string;
  content: string;
  rewardStats: StoreState["reward"]["rewardStats"];
}

export class CurrentTier extends ComponentBase<CurrentTierProps> {
  // tslint:disable:cyclomatic-complexity
  render() {
    const {
      style,
      classNames,
      rewardStats,
      action,
      successScreen,
      mode,
      isEditing,
    } = this.props;
    const currentTier = get(rewardStats, "tierResult.currentTier");

    return (
      <div
        onDragStart={this.onDragStart}
        id={this.props.configName}
        onAnimationEnd={this.resetAnimation}
        style={{
          ...style,
          cursor: action || successScreen ? "pointer" : "inherit",
        }}
        className={`CurrentTier-text  CurrentTier-mode-${
          mode || "default"
        } ${classNames || ""} ${
          !isEditing ? "CurrentTier-text-preview" : ""
        } ${this.state.animationClass}`}
        aria-label={get(this.props, "label", "")}
        tabIndex={action ? 0 : undefined}
        ref={(component) => (this.component = component)}
      >
        {currentTier}
      </div>
    );
  }
}
